/**
 * SEO <title> overrides for blog posts. These affect the document title only;
 * the on-page H1 and all body copy still come from the post record.
 * Every override is kept at or under 60 characters so Google does not truncate
 * it, with the primary keyword in the first half.
 */
export const BLOG_TITLE_OVERRIDES: Record<string, string> = {
  "ppc-agencies-for-home-services-companies-in-arizona":
    "PPC Agencies for Home Services Companies in Arizona, Compared",
  "google-guaranteed-badge-google-verified":
    "Google Guaranteed Is Now Google Verified: What Changed",
  "call-tracking-for-contractors":
    "Call Tracking for Contractors: Which Ads Ring the Phone",
  "google-ads-negative-keyword-scripts-stop-pmax-cannibalization":
    "Negative Keyword Scripts to Stop PMax Cannibalization",
  "boost-lsa-rank-the-review-acceleration-playbook-for-home-services":
    "Boost LSA Rank: The Review Playbook for Home Services",
  "scaling-design-build-landscaper-meta-ads-cac-creative-strategy":
    "Design-Build Landscaper Meta Ads: CAC & Creative",
  "recurring-vs-deep-clean-ads-ltv-bidding-for-cleaning-companies":
    "Cleaning Company Ads: LTV Bidding for Recurring Jobs",
  "do-youtube-ads-increase-google-search-volume-for-home-services":
    "Do YouTube Ads Increase Branded Search for Home Services?",
  "how-to-structure-roofing-google-ads-and-lsa-for-retail-leads":
    "Structuring roofing Google Ads and LSA for retail leads",
  "mastering-lsa-disputes-recover-20-of-monthly-ad-spend":
    "LSA Lead Credits in 2026: What Google Refunds Now",
  "why-does-meta-report-more-purchases-than-my-store":
    "Meta Shows More Purchases Than Shopify? Fix the Double Count",
  "why-did-my-google-ads-conversions-stop":
    "Google Ads Conversions Dropped to Zero? Check These 5 Things",
  "how-to-allocate-dtc-media-spend-between-meta-and-google-ads":
    "How DTC Brands Diversify Off Meta: Meta vs Google Budget Split",
  "demand-gen-vs-display-which-ad-type-fits-your-media-mix":
    "Demand Gen vs Display Ads in Google Ads: Which to Use",
};

/**
 * Head-only meta description overrides. These feed <meta name="description">,
 * og:description and twitter:description; the on-page standfirst paragraph and
 * the BlogPosting JSON-LD description keep coming from the post record.
 */
export const BLOG_META_DESCRIPTION_OVERRIDES: Record<string, string> = {
  "local-services-ads-for-contractors":
    "How Google Local Services Ads work for contractors in 2026: verification, Google Verified badge, ranking, bidding, lead credits and the move into Google Ads.",
  "google-guaranteed-badge-google-verified":
    "Google retired the Google Guaranteed badge and its money-back guarantee. What Google Verified means, what changed, and where to update the old badge.",
  "call-tracking-for-contractors":
    "Most contractor leads are phone calls, and most ad accounts can't see them. How call tracking works, your Google Ads options, and mistakes that hide leads.",
  "scaling-home-services-meta-ads-cutting-cpl-from-86-to-34":
    "How home-services operators lower Meta Ads cost per lead: creative-led broad targeting, higher-intent forms, and usable conversion data.",
  "mastering-lsa-disputes-recover-20-of-monthly-ad-spend":
    "How Google Local Services Ads lead credits work in 2026: automatic credits, the 30-day review, Rate this lead, and the leads Google no longer refunds.",
  "why-does-meta-report-more-purchases-than-my-store":
    "Meta showing more sales than your store took? The pixel and the Conversions API are often counting the same purchase twice. How to check it and fix it.",
  "why-did-my-google-ads-conversions-stop":
    "Conversions stopped overnight? It is almost always tracking, not the ads. The five breaks we find most often, in the order to check them.",
  "how-to-allocate-dtc-media-spend-between-meta-and-google-ads":
    "Most DTC brands lean too hard on Meta. How to move budget into Google Ads without losing sales: what each channel does, how to split spend under $50K a month, and when to shift.",
  "demand-gen-vs-display-which-ad-type-fits-your-media-mix":
    "Demand Gen vs Display ads, side by side: where each one runs, who it reaches, and which fits a lead-gen budget for home services like roofing and HVAC.",
};

/** Social/search-only updates, preserving existing article structured data. */
export const BLOG_HEAD_DESCRIPTION_OVERRIDES: Record<string, string> = {
  "how-to-allocate-dtc-media-spend-between-meta-and-google-ads":
    "How to move DTC budget into Google Ads without losing sales: what each channel does, how to split spend under $50K a month, and when to shift.",
  "roofing-leads-buy-vs-lsa-vs-google-ads":
    "Where roofing leads come from, what each source costs, and the one number that decides which is cheapest: cost per signed job, not cost per lead.",
};

/** Only these existing headlines matched the previous document title. */
export const BLOG_PREVIOUS_SEO_TITLES: Record<string, string> = {
  "google-guaranteed-badge-google-verified": "Google Guaranteed Is Now Google Verified: What Contractors Need to Know",
  "call-tracking-for-contractors": "Call Tracking for Contractors: How to Know Which Ads Make the Phone Ring",
  "mastering-lsa-disputes-recover-20-of-monthly-ad-spend": "Local Services Ads Lead Credits in 2026: What Google Refunds Now",
};
